import React from 'react';

export const GreyTrophy = (): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
  >
    <circle cx="15" cy="15" r="15" fill="#DBDDE0" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4 10.1244C11.4 9.79304 11.6686 9.52441 12 9.52441H18C18.3314 9.52441 18.6 9.79304 18.6 10.1244V11.9244H20.4C20.7314 11.9244 21 12.193 21 12.5244C21 14.7793 19.223 16.6192 16.993 16.7201C16.4877 17.724 16.0518 18.7757 15.9566 19.7887C17.1187 19.9484 18.0456 20.3921 18.4202 20.9611C18.6024 21.2379 18.3314 21.5244 18 21.5244H12C11.6686 21.5244 11.3976 21.2379 11.5798 20.9611C11.9544 20.3921 12.8813 19.9484 14.0434 19.7887C13.9482 18.7757 13.5123 17.724 13.007 16.7201C10.777 16.6192 9 14.7793 9 12.5244C9 12.193 9.26863 11.9244 9.6 11.9244H11.4V10.1244ZM9.91345 12.8244H11.4241C11.4914 13.6062 11.6955 14.2548 11.9796 14.7923C12.0964 15.0131 12.2199 15.2404 12.3462 15.4727L12.3465 15.4732C12.3961 15.5645 12.4461 15.6565 12.4963 15.7492C11.1068 15.4474 10.0438 14.2704 9.91345 12.8244ZM17.6538 15.4727C17.6041 15.5641 17.554 15.6563 17.5037 15.7492C18.8932 15.4474 19.9562 14.2704 20.0865 12.8244H18.5759C18.5086 13.6062 18.3045 14.2548 18.0204 14.7923C17.9036 15.0131 17.7801 15.2404 17.6538 15.4727Z"
      fill="#545D68"
    />
  </svg>
);
